import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { components } from 'react-select';

const SelectContainer = ({ children, selectProps, hasValue, isFocused, ...props }) => (
  <components.SelectContainer
    {...props}
    hasValue={hasValue}
    isFocused={isFocused}
    className={classnames('ncss-select', { isActive: isFocused || hasValue, hasValue })}
  >
    <div className='pt4-sm' data-desc={`select__${selectProps.input.name}_container`}>
      {children}
    </div>
  </components.SelectContainer>
);

SelectContainer.defaultProps = {
  children: null
};

SelectContainer.propTypes = {
  children: PropTypes.any,
  selectProps: PropTypes.any.isRequired,
  isFocused: PropTypes.bool.isRequired,
  hasValue: PropTypes.bool.isRequired
};

export default SelectContainer;
